/* import __COLOCATED_TEMPLATE__ from './own-cards-deactivation-success.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();